<form [formGroup]="damageCodeFilterForm">
  <div class="form-content">
    <div class="pure-g">
      <div class="pure-u-md-24-24">
        <div class="pure-u-md-12-24 p-b-12 p-r-16">
          <mc-multi-select
            label="Damage Code - Description"
            fit="medium"
            width="100"
            placeholder="Select an Option"
            ngDefaultControl
            formControlName="damageCodeDescriptionList">
            @for (damageCode of damageCodeDescriptionList; track damageCode.id) {
              <mc-option [attr.data-cy]="damageCode.code" [value]="damageCode.id"
                >{{ damageCode.code }} - {{ damageCode.description }}</mc-option
              >
            }
          </mc-multi-select>
        </div>

        <div class="pure-u-md-12-24 p-b-12 p-r-16">
          <mc-multi-select
            label="Damage Type"
            fit="medium"
            width="100"
            placeholder="Select an Option"
            ngDefaultControl
            formControlName="damageTypesList">
            @for (damageType of damageTypesList; track damageType.code) {
              <mc-option [attr.data-cy]="damageType.code" [value]="damageType.code">{{ damageType.description }}</mc-option>
            }
          </mc-multi-select>
        </div>
      </div>
    </div>
  </div>
  <div class="pure-u-md-24-24 utility-buttons">
    <mc-button
      label="Apply Filters"
      slot="primaryAction"
      variant="filled"
      appearance="primary"
      fit="medium"
      (click)="applyFilters()"
      (keydown.enter)="applyFilters()"
      (keydown.space)="applyFilters()"
      class="p-r-16"></mc-button>
    <mc-button
      label="Clear Filters"
      slot="secondaryAction"
      appearance="neutral"
      fit="medium"
      (click)="clearFilters()"
      (keydown.enter)="clearFilters()"
      (keydown.space)="clearFilters()"
      class="p-r-16"></mc-button>
  </div>
</form>
